import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { AppSettings } from "../../app-settings";

interface TimeFrame {
  label: string;
  value: number;
  selected?: boolean;
}

@Component({
  selector: "app-dashboard-time-tracking",
  templateUrl: "./dashboard-time-tracking.component.html",
  styleUrls: ["./dashboard-time-tracking.component.scss"],
})
export class DashboardTimeTrackingComponent implements OnInit, OnChanges {
  iconClockUrl = AppSettings.cdnUrl + "assets/images/ico-clock.svg";
  iconTimeUrl = AppSettings.cdnUrl + "assets/images/ico-time-new.svg";
  iconNextUrl = AppSettings.cdnUrl + "assets/images/ico-next-black.svg";
  iconPrevUrl = AppSettings.cdnUrl + "assets/images/ico-prev-black.svg";
  iconGoals = AppSettings.cdnUrl + "assets/images/ico-goals.svg";
  iconCorrect = AppSettings.cdnUrl + "assets/images/ico-correct.svg";
  totalTimeSpent: number = 0;
  weeklyGoalProgress: number = 5;
  weeklyGoalTotal: number = 7;
  selectedDays: number = 8;
  selectedTimeFrame: string = "Last 8 days";

  isDropdownOpen = false;
  daysArray: number[] = [];

  icoConsistencyUrl = AppSettings.cdnUrl + "assets/images/ico-consistency.svg";
  icoStudyUrl = AppSettings.cdnUrl + "assets/images/ico-study.svg";
  icoBreakUrl = AppSettings.cdnUrl + "assets/images/ico-break.svg";
  icoRecentUrl = AppSettings.cdnUrl + "assets/images/ico-recent-black.svg";

  @Input() data: any; // Input for the tracking data

  trackingData = {
    committedTimeMap: null,
    progressStreak: null,
    defaultCommittedTime: true,
    userTimeSpent: null,
    weekType: "current",
  };

  dataGenerated: boolean = false;

  // weekType: string = 'current';
  weekType: string = "current";

  timeFrameOptions: TimeFrame[] = [
    { label: "Last 7 days", value: 8, selected: true },
    { label: "Last 15 days", value: 15 },
    { label: "Last 30 days", value: 30 },
  ];

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.dataGenerationForWeek();
  }

  weekChange(type) {
    switch (type) {
      case "next":
        if (this.weekSwitchEnabled(type)) {
          this.weekType = "current";
          this.dataGenerationForWeek();
        }
        break;
      case "prev":
        if (this.weekSwitchEnabled(type)) {
          this.weekType = "previous";
          this.dataGenerationForWeek();
        }
        break;
    }
  }

  weekSwitchEnabled(type){
    switch(type){
      case 'prev':
        return (this.data?.previousWeekStreak?.available && this.weekType === 'current');
      case 'next':
        return (this.data?.currentWeekStreak?.available && this.weekType !== 'current');
    }
  }
  getProgressStreakData(){
    switch(this.weekType){
      case 'current':
        if(this.data?.currentWeekStreak?.available){
          return this.data?.currentWeekStreak
        }
      case 'previous':
        if(this.data?.previousWeekStreak?.available){
          return this.data?.previousWeekStreak
        }
    }
    return null;
  }
  dataGenerationForWeek() {
    this.trackingData = {
      committedTimeMap: this.data.committedTimeMap,
      progressStreak: this.getProgressStreakData(),
      defaultCommittedTime: this.data.defaultCommittedTime,
      userTimeSpent: this.data.userTimeSpent,
      weekType: this.weekType,
    };
    console.log(this.trackingData?.progressStreak);
    this.dataGenerated = true;
  }
  ngOnInit(): void {}

  getStatusClass(status: string): string {
    switch (status) {
      case "COMPLETED_AUTO":
      case "COMPLETED_MANUAL":
        return "Completed";
      case "INPROGRESS":
        return "In Progress";
      case "NEW":
        return "New";
      case "REVISION":
        return "Revision";
    }
  }

  /**
   * Receives the weekly total from <app-graph-time-tracking-highchart>.
   *
   * The child emits this synchronously from its ngOnInit / ngOnChanges, i.e. in the
   * middle of THIS view's change-detection pass. The `{{ totalTimeSpent }}` binding
   * sits above the child in the template, so it has already been checked by then;
   * assigning here directly changes a checked expression and dev builds throw
   * ExpressionChangedAfterItHasBeenCheckedError ('0h 0m' -> '0h 3m').
   *
   * Deferring to a microtask moves the write out of the current pass. zone.js runs
   * another pass once the microtask queue drains, still before the browser paints,
   * so the header updates in the same frame with no visible flicker.
   */
  CalculateTotalTimeSpent(minutes: number) {
    Promise.resolve().then(() => {
      this.totalTimeSpent = minutes;
    });
  }

  formatTimeFromMinutes(totalMinutes: number): string {
    // Calculate hours and remaining minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.round(totalMinutes % 60);

    // Handle edge case where rounding minutes results in 60
    if (minutes === 60) {
      return `${hours + 1}h 0m`;
    }

    // Return formatted string
    return `${hours}h ${minutes}m`;
  }

  get selectedOption(): TimeFrame {
    return (
      this.timeFrameOptions.find((option) => option.selected) ||
      this.timeFrameOptions[0]
    );
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(option: TimeFrame): void {
    // Deselect all options
    this.timeFrameOptions.forEach((opt) => (opt.selected = false));

    // Select the clicked option
    option.selected = true;

    // Close dropdown
    this.isDropdownOpen = false;

    this.selectedDays = option.value;

    // Emit the selected option
  }
}
